export const ROLE_LABELS = {
  operations: "Operations",
  management: "Management",
  team_lead: "Team Lead",
  cafe_employee: "Cafe Employee",
};

export const ACCESS_LABELS = {
  admin: "Admin",
  podcast_creator: "Podcast Creator",
  consumer: "Consumer",
};

export function hasAccess(user, access) {
  return !!user && (user.access || []).includes(access);
}

export function canSeeMetrics(user) {
  return !!user && ["operations", "management", "team_lead"].includes(user.role);
}

export function canAuthorArticles(user) {
  return !!user && ["operations", "management", "team_lead"].includes(user.role);
}

export function canNudge(user) {
  return !!user && ["operations", "management", "team_lead"].includes(user.role);
}

export function canNudgeAll(user) {
  return !!user && ["operations", "management"].includes(user.role);
}

export function formatDuration(sec) {
  if (!sec && sec !== 0) return "--:--";
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
}
